import React, { useState } from "react";
import "../styles.css";
import moment from "moment";
import { Input } from "../../../../components/Input";

const brl = (value) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);

export const BoletoCard = ({ boleto, getTicket }) => {
  const [codBoleto, setCodBoleto] = useState(boleto?.barcode);
  const [codBoletoError, setCodBoletoError] = useState("");
  const [ticketLoader, setTicketLoader] = useState(false);

  const validateBoletoResponse = (boletoResult) => {
    if (!boletoResult || !boletoResult.barcode || boletoResult.value <= 0) {
      return "Boleto inválido. Verifique as informações e tente novamente.";
    }

    if (
      !boletoResult.dueDate ||
      (typeof boletoResult.dueDate === "string" &&
        boletoResult.dueDate.trim() === "")
    ) {
      return "Data inválida ou não fornecida. Por favor, preencha a data.";
    }

    return "";
  };


  function validateType(barCode) {
    const clean = barCode.replace(/\D/g, "");
    if (clean.length !== 44) return false;

    if (!clean.startsWith("8")) return false;
    return true;
  }


  const validateBoleto = (code) => {
    if (!/^[\d.\s]+$/.test(code)) {
      return "O código do boleto deve conter apenas números.";
    }

    if (code.length < 47) {
      return "O código do boleto é muito curto. Verifique e tente novamente.";
    }

    return "";
  };

  const handleProceed = async () => {
    setCodBoletoError("");
    setTicketLoader(true);

    try {
      const validationError = validateBoleto(codBoleto);
      if (validationError) {
        setCodBoletoError(validationError);
        return;
      }

      const boletoResult = await getTicket(codBoleto);

      const responseError = validateBoletoResponse(boletoResult);
      if (responseError) {
        setCodBoletoError(responseError);
        return;
      }
    } catch (error) {
      console.error("Erro ao validar o boleto:", error.message);
      setCodBoletoError("Erro ao validar o boleto. Erro: " + error.message);
    } finally {
      setTicketLoader(false);
    }
  };

  // LOADING
  if (ticketLoader) {
    return (
      <section
        className="boleto-section"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "200px",
          backgroundColor: "#f9fafb",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        <div className="loader" style={{ textAlign: "center" }}>
          <div
            className="spinner"
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #ccc",
              borderTop: "4px solid #000",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 12px",
            }}
          ></div>
          <p style={{ color: "#000", fontSize: "14px" }}>Carregando boleto...</p>
        </div>

        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </section>
    );
  }

  // RENDER PADRÃO
  return (
    <section className="boleto-section">
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center"></div>
          <div>
            <p className="text-sm text-black">{boleto?.bankName}</p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <h2 className="text-lg font-semibold text-black">
                {boleto?.identifier}
              </h2>
              <button
                onClick={handleProceed}
                style={{ borderRadius: "12px" }}
                className="text-sm px-3 py-2 rounded-xl border text-black border-black hover:border-gray-700"
              >
                Alterar boleto
              </button>
            </div>

            <Input
              type="text"
              value={codBoleto}
              onChange={setCodBoleto}
              max={47}
              error={codBoletoError}
              readOnly
              style={{
                backgroundColor: "#f9fafb",
                padding: "8px 16px",
                borderRadius: "12px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                border: "none",
                width: "70% !important",
                marginBottom: "20px",
                marginTop: "20px",
              }}
            />

            <div
              style={{
                marginTop: "8px",
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "12px",
                fontSize: "14px",
              }}
            >
              {/* Card: Vencimento */}
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  padding: "8px 16px",
                  borderRadius: "12px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span style={{ color: "#6b7280", fontSize: "12px" }}>
                  Vencimento:
                </span>
                <span style={{ fontWeight: "600", color: "#000" }}>
                  {boleto?.dueDate
                    ? moment(boleto.dueDate).format("DD/MM/YYYY")
                    : "-"}
                </span>
              </div>

              {/* Card: Valor */}
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  padding: "8px 16px",
                  borderRadius: "12px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span style={{ color: "#6b7280", fontSize: "12px" }}>Valor:</span>
                <span style={{ fontWeight: "600", color: "#000" }}>
                  {boleto?.totalValue ? brl(String(boleto.totalValue)) : "-"}
                </span>
              </div>

              {/* Card: Situação */}
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  padding: "8px 16px",
                  borderRadius: "12px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span style={{ color: "#6b7280", fontSize: "12px" }}>
                  Situação:
                </span>
                <span
                  style={{
                    fontWeight: "600",
                    color: boleto?.paymentWasMade ? "#000" : "#059669",
                  }}
                >
                  {boleto.totalValue
                    ? boleto.paymentDate
                      ? "Pago"
                      : "A pagar"
                    : "-"}
                </span>
              </div>

              {/* Card: Tipo */}
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  padding: "8px 16px",
                  borderRadius: "12px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span style={{ color: "#6b7280", fontSize: "12px" }}>Tipo:</span>
                <span style={{ fontWeight: "600", color: "#000" }}>
                  {boleto?.barcode ?
                  validateType(boleto?.barcode) ? "consumo" : "boleto bancário"
                  : "-"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
